import { businessIanaTimeZone } from "@/business/time-zones";
import { useBusiness } from "@/core/business";

/**
 * The selected business's IANA zone, which AP dates are read in. Undefined
 * (the browser's zone) when the business has no zone the app knows.
 */
export const useApBusinessTimeZone = (): string | undefined => {
  const { selectedBusiness } = useBusiness();
  return businessIanaTimeZone(selectedBusiness?.time_zone_label);
};
